import Link from 'next/link';

import React from 'react';

import styled from 'styled-components';

import { Container } from '@components/parts/Container';

import { CrossSelling as TCrossSelling } from '@customTypes/CrossSelling';

type Props = { services: TCrossSelling };

const Wrapper = styled.div`
  padding-top: 50px;
  padding-bottom: 90px;
  @media (min-width: 992px) {
    padding-top: 70px;
    padding-bottom: 160px;
  }
  h5 {
    margin-bottom: 40px;
    @media (min-width: 992px) {
      margin-bottom: 50px;
    }
  }
  .services {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    @media (min-width: 992px) {
      grid-gap: 20px;
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    div.image {
      background-size: cover;
      background-position: center;
      height: 120px;
      @media (min-width: 992px) {
        height: 160px;
      }
    }
    .name {
      font-size: 15px;
      color: #2e3035;
      font-weight: 500;
      margin-bottom: 5px;
      margin-top: 14px;
      @media (min-width: 992px) {
        margin-top: 18px;
        margin-bottom: 8px;
        font-size: 18px;
      }
    }
    .description {
      font-size: 14px;
      margin-bottom: 14px;
      color: #62656a;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      @media (min-width: 992px) {
        font-size: 15px;
      }
    }
  }
`;

export const RelatedServices: React.FC<Props> = (props) => {
  const { services } = props;

  return (
    <Container style={{ backgroundColor: '#F3F4F8' }}>
      <Wrapper>
        <h5>관련 서비스</h5>
        <div className="services">
          {(services?.data || []).slice(0, 4).map((service, idx) => (
            <Link key={idx} href={service.attributes.href ?? '/services'}>
              <div
                className="image"
                style={{ backgroundImage: `url('${service.attributes.image?.data?.attributes?.url || ''}')` }}
              ></div>
              <div className="name">{service.attributes.name}</div>
              <p className="description">{service.attributes.description}</p>
            </Link>
          ))}
        </div>
      </Wrapper>
    </Container>
  );
};
